import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { T4ReportPageSetup } from "../../../components/Reports/T4Report";

export interface IT4ReportPage {}

export const T4ReportPage: FC<IT4ReportPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="T4 Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<T4ReportPageSetup />}
		/>
	);
};
